// extracted by mini-css-extract-plugin
module.exports = {"bless_h3":"AlbumListPage_bless_h3__3auE-"};